import { Phone, Mail, Lock } from "lucide-react";
import { Logo, EUFlag, WhatsAppIcon } from "./Extras";
import { NAV_LINKS, CATALOG_URL, buildWhatsAppUrl } from "../data/content";

const Footer = ({ config, base = "" }) => (
    <footer id="contacto" data-testid="site-footer" className="bg-brand-purple text-white">
        <div className="mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8">
            <div className="grid gap-10 md:grid-cols-3">
                <div>
                    <Logo className="h-14" />
                    <p className="mt-4 max-w-xs text-sm leading-relaxed text-white/70">
                        Alimentos y complementos de calidad europea para aves, conejos y roedores.
                    </p>
                    <span
                        data-testid="footer-eu-badge"
                        className="mt-5 inline-flex items-center gap-2 rounded-full bg-white/10 px-4 py-2 text-xs font-bold uppercase tracking-widest text-white"
                    >
                        <EUFlag /> Producto Europeo
                    </span>
                </div>
                <nav aria-label="Enlaces del sitio">
                    <h3 className="font-display text-sm font-bold uppercase tracking-widest text-brand-magenta">Explorar</h3>
                    <ul className="mt-4 space-y-2.5">
                        {NAV_LINKS.map((l) => (
                            <li key={l.href}>
                                <a
                                    data-testid={`footer-nav-${l.href.slice(1)}`}
                                    href={`${base}${l.href}`}
                                    className="text-sm text-white/70 transition-colors duration-200 hover:text-white"
                                >
                                    {l.label}
                                </a>
                            </li>
                        ))}
                        <li>
                            <a
                                data-testid="footer-nav-catalogo"
                                href={CATALOG_URL}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-sm text-white/70 transition-colors duration-200 hover:text-white"
                            >
                                Catálogo PDF
                            </a>
                        </li>
                    </ul>
                </nav>
                <div>
                    <h3 className="font-display text-sm font-bold uppercase tracking-widest text-brand-magenta">Contacto</h3>
                    <ul className="mt-4 space-y-3 text-sm text-white/70">
                        <li>
                            <a data-testid="footer-phone" href={`tel:+506${(config?.phone || "2296-2371").replace("-", "")}`} className="inline-flex items-center gap-2 transition-colors duration-200 hover:text-white">
                                <Phone className="h-4 w-4" /> {config?.phone || "2296-2371"}
                            </a>
                        </li>
                        <li>
                            <a data-testid="footer-email" href={`mailto:${config?.email || "info@tugeko.com"}`} className="inline-flex items-center gap-2 transition-colors duration-200 hover:text-white">
                                <Mail className="h-4 w-4" /> {config?.email || "info@tugeko.com"}
                            </a>
                        </li>
                        <li>
                            <a
                                data-testid="footer-whatsapp"
                                href={buildWhatsAppUrl(config?.whatsapp)}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="inline-flex items-center gap-2 transition-colors duration-200 hover:text-white"
                            >
                                <WhatsAppIcon className="h-4 w-4" /> WhatsApp
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
            <div className="mt-12 border-t border-white/15 pt-8 text-center">
                <p data-testid="footer-distributor" className="text-sm font-semibold text-white">
                    Distribuido por Tugeko S.A.
                </p>
                <span className="mt-4 inline-flex items-center">
                    <img
                        data-testid="footer-tugeko-logo"
                        src="/assets/logo-tugeko-white.png"
                        alt="Tugeko S.A."
                        className="h-7 w-auto"
                    />
                </span>
                <p data-testid="footer-legal" className="mx-auto mt-4 max-w-xl text-sm leading-relaxed text-white/60">
                    No hacemos ventas al cliente final. Disponible en las principales veterinarias y
                    pet shops del país.
                </p>
                <a
                    data-testid="footer-admin-link"
                    href="/admin"
                    className="mt-6 inline-flex min-h-[44px] items-center gap-1.5 rounded-full border border-white/15 px-5 text-xs font-semibold text-white/50 transition-colors duration-200 hover:border-white/40 hover:text-white"
                >
                    <Lock className="h-3.5 w-3.5" /> Acceso administrador
                </a>
            </div>
        </div>
    </footer>
);

export default Footer;
